module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Save-d760650058ccb50711680e2138d23edbbdc4c668b93801547d81201823a03b10.svg";